const getters = {
    getServiceRequestList(state) {
        return state.serviceRequestList;
    },
    getServiceRequest(state) {
        return state.serviceRequest;
    }
}

export default getters;